export enum CalendarType {
  Kanban = "Kanban",
  Scheduler = "Scheduler",
  HoldsList = "HoldsList",
  PriorityScheduler = "PriorityScheduler",
  AutoHold = "AutoHold",
}
